import React, { useState, useEffect, useCallback } from 'react';
import './influencer.css';
import { useLanguage } from '../contexts/LanguageContext';
import resmailLogo from '../assets/resmail.png';
import aboutLogo from '../assets/lamp.svg';
import affiliateImage from '../assets/affiliate/aff-no.svg';
import affiliateImg from '../assets/affiliate-img.svg';
import Pro from '../assets/pro.svg';
import Tfu from '../assets/tfu.svg';
import aff1 from '../assets/affiliate/aff1.svg';
import aff2 from '../assets/affiliate/aff2.svg';
import aff3 from '../assets/affiliate/aff3.svg';
import aff4 from '../assets/affiliate/aff4.svg';
import aff5 from '../assets/affiliate/aff5.1.svg';
import aff6 from '../assets/affiliate/aff6.svg';
import aff7 from '../assets/affiliate/aff7.1.svg';
import aff8 from '../assets/affiliate/aff8.1.svg';
import bubbleImage from '../assets/bubble.svg';
import Table from './table';
import './table.css';

function Influencer() {
    const { isArabic, setLanguage } = useLanguage();
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        setLanguage('en');
    }, [setLanguage]);

    const handleSearch = (e) => {
        e.preventDefault();
        // Handle search logic here
        console.log('Searching for:', searchQuery);
    };

    return (
        <div className="affiliate-page">
            <section className="affiliate-hero">
                <div className="affiliate-hero-container">
                    <div className="affiliate-hero-left">
                        {/* <div className="affiliate-search-wrapper">
                            <form onSubmit={handleSearch} className="affiliate-search-form">
                                <input
                                    type="text"
                                    placeholder={isArabic ? "ابحث عن الشركات التابعة..." : "Search for affiliates..."}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="affiliate-search-input"
                                />
                                <button type="submit" className="affiliate-search-button">
                                    {isArabic ? "بحث" : "Search"}
                                </button>
                            </form>
                        </div> */}
                        <div className="affiliate-content">
<Table type="influencer" title="ARTISTS" pointsLabel="Rank" />
                        </div>
                    </div>
                    <div className="affiliate-hero-right">
                        <img src={affiliateImage} alt="Affiliate" className="affiliate-hero-image" />
                    </div>
                </div>
            </section>

            <section className="leaderboard-section">
  <div className="leaderboard-image-container">
    <img src={Pro} alt="Affiliate" />
  </div>
  <div className="leaderboard-content">
    <h3>GET ON TOP OF<br />THE LEADERBOARD</h3>
    <div className="leaderboard-prize">
      <img src={Tfu} alt="Affiliate" />
      <div className="leaderboard-prize-text">
        And win a Europe show trip with all expenses paid
      </div>
    </div>
  </div>
</section>
        </div>
    );
}

export default Influencer;


// const Table = () => {
//   const [data, setData] = useState([]);
//   const [summary, setSummary] = useState(null);
//   const [lastUpdate, setLastUpdate] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);

// //   const API_URL = 'http://localhost:3000/api/affiliate/stats'; // Change to your backend URL
//   const REFRESH_INTERVAL = 10 * 60 * 1000; // 10 minutes
// const API_URL = 'http://localhost:8000';

//   const fetchData = useCallback(async () => {
//     setIsLoading(true);
//     setError(null);
    
//     try {
//       console.log('🔄 Fetching data from backend...');
      
//       const response = await fetch(`${API_URL}/api/affiliate/stats`);
      
//       if (!response.ok) {
//         throw new Error(`HTTP ${response.status}: ${response.statusText}`);
//       }
      
//       const result = await response.json();
      
//       if (!result.success) {
//         throw new Error(result.error || 'Unknown error');
//       }
      
//       // Sort by revenue descending
//       const sortedData = [...result.stats].sort((a, b) => b.revenue - a.revenue);
      
//       setData(sortedData);
//       setSummary(result.summary);
//       setLastUpdate(new Date(result.lastUpdate));
      
//       console.log(`✅ Data loaded: ${result.stats.length} codes`);
      
//     } catch (err) {
//       console.error('❌ Error loading data:', err);
//       setError(err.message);
//     } finally {
//       setIsLoading(false);
//     }
//   }, [API_URL]);

//   // Initial load
//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   // Auto-refresh every 10 minutes
//   useEffect(() => {
//     const interval = setInterval(() => {
//       console.log('⏰ Auto-refresh triggered');
//       fetchData();
//     }, REFRESH_INTERVAL);

//     return () => clearInterval(interval);
//   }, [fetchData, REFRESH_INTERVAL]);

//   if (isLoading && data.length === 0) {
//     return (
//       <div className="table-container">
//         <div className="loading">Loading initial data...</div>
//       </div>
//     );
//   }

//   if (error && data.length === 0) {
//     return (
//       <div className="table-container">
//         <div className="error">
//           <strong>Error loading data:</strong> {error}
//           <br /><br />
//           <button onClick={fetchData}>Retry</button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="table-container">
//       <table className="data-table">
//         <thead>
//           <tr>
//             <th data-label="Code">Code</th>
//             <th data-label="Name">Name</th>
//             <th data-label="Revenue">Revenue (€)</th>
//             <th data-label="Commission">Commission (€)</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((row, index) => (
//             <tr key={row.code || index}>
//               <td data-label="Code">
//                 <strong>{row.code}</strong>
//               </td>
//               <td data-label="Name">{row.name}</td>
//               <td data-label="Revenue">€{row.revenue.toFixed(2)}</td>
//               <td data-label="Commission">€{row.commission.toFixed(2)}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

